import { render, staticRenderFns } from "./EditableFormatSummaryTagFilter.vue?vue&type=template&id=18c47d7b&scoped=true&"
import script from "./EditableFormatSummaryTagFilter.vue?vue&type=script&lang=ts&"
export * from "./EditableFormatSummaryTagFilter.vue?vue&type=script&lang=ts&"
import style0 from "./EditableFormatSummaryTagFilter.vue?vue&type=style&index=0&id=18c47d7b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c47d7b",
  null
  
)

export default component.exports